import { PredefinedFiltersEnum } from '@app/app.enum';
import { dashboardEndDate, dashboardStartDate } from '@app/constants';
import * as models from '@app/models';
import Injector from '@app/services';
import { InjectedIntl } from 'react-intl';
import { IntlService } from '../services/intl.service';
import { initialUser, IUser } from './account.models';
import { IAxiosCancellation } from './core.models';

const intlService: IntlService = Injector.get(IntlService);
export interface IShipmentDashboard {
	date: Date;
	prePayShipmentCount: number;
	prePayShipmentFee: number;
	specialServicesCost: number;
	postPayShipmentCount: number;
	postPayShipmentFee: number;
}

export interface IDashboard {
	companyName: string;
	firstName: string;
	lastName: string;
	shipmentData: IShipmentDashboard[];
	billingHistory: models.IPagedResult<models.IAccountTransaction>;
}

export interface IDashboardComponentProps extends IAxiosCancellation, models.ISnackBarFeature {
	intl: InjectedIntl;
}

export interface IProfileCompleteness {
	isUserInfoSetUp: boolean;
	isShipFromAddressExist: boolean;
	isCarrierAccountSetUp: boolean;
	isPaymentSetUp: boolean;
	isContainsOnlyePostageCarrier: boolean;
	ePostageAppId: string;
	userInfoSetUpOrder: number;
	shipFromAddressExistOrder: number;
	carrierAccountSetUpOrder: number;
	paymentSetUpOrder: number;
	percentage: number;
}
export interface IDashboardState extends models.IPagedResult<models.IAccountTransaction> {
	totalShipment: Chart.ChartData;
	shipmentFee: Chart.ChartData;
	balance: Chart.ChartData;
	fees: Chart.ChartData;
	user: IUser;
	accountStatementPageSize: number;
	todayTransactionFeesPrePay: number;
	todayTransactionPrePay: number;
	startDate: Date;
	endDate: Date;
	currentPage: number;
	predefinedFilterValue: PredefinedFiltersEnum;
	dataLoading: boolean;
	profileCompleteness: IProfileCompleteness;
	day: number;
	todayTransactionPostPay: number;
	todayTransactionFeesPostPay: number;
}

export const initialDashboardState = (): IDashboardState => ({
	results: [],
	nextPage: null,
	previousPage: null,
	pageSize: 0,
	totalPages: 0,
	totalResults: 0,
	currentPage: 1,
	totalShipment: {
		datasets: [
			{
				fill: true,
				lineTension: 0.1,
				label: intlService.GetFormattedMessage('app.dashboard-number-of-shipment'),
				backgroundColor: 'rgba(117,214,231,1)',
				borderColor: 'rgba(117,214,231,1)',
			},
		],
	},
	shipmentFee: {
		datasets: [
			{
				fill: true,
				lineTension: 0.1,
				label: intlService.GetFormattedMessage('app.dashboard-total-cost'),
				backgroundColor: 'rgba(117,214,231,1)',
				borderColor: 'rgba(117,214,231,1)',
			},
			{
				fill: true,
				lineTension: 0.1,
				label: intlService.GetFormattedMessage('app.dashboard-special-service-cost'),
				backgroundColor: 'rgba(255,154,170,1)',
				borderColor: 'rgba(255,154,170,1)',
			},
		],
	},
	balance: {
		datasets: [
			{
				fill: true,
				lineTension: 0.1,
				label: intlService.GetFormattedMessage('app.dashboard-max-balance-limit'),
				backgroundColor: ['rgba(117,214,231,1)', 'rgba(255,154,170,1)', 'rgba(196,146,238,1)'],
				borderColor: ['rgba(117,214,231,1)', 'rgba(255,154,170,1)', 'rgba(196,146,238,1)'],
			},
		],
	},
	fees: {
		datasets: [
			{
				fill: false,
				lineTension: 0.1,
				label: intlService.GetFormattedMessage('app.dashboard-fees'),
				backgroundColor: 'rgba(117,214,231,1)',
				borderColor: 'rgba(117,214,231,1)',
			},
		],
	},
	user: initialUser(),
	accountStatementPageSize: 10,
	todayTransactionFeesPrePay: 0,
	todayTransactionPrePay: 0.0,
	startDate: dashboardStartDate.toDate(),
	endDate: dashboardEndDate.toDate(),
	predefinedFilterValue: PredefinedFiltersEnum.Custom,
	dataLoading: true,
	profileCompleteness: {
		isUserInfoSetUp: true,
		isShipFromAddressExist: false,
		isContainsOnlyePostageCarrier: false,
		isCarrierAccountSetUp: false,
		isPaymentSetUp: false,
		ePostageAppId: null,
		percentage: 100,
		userInfoSetUpOrder: 1,
		shipFromAddressExistOrder: 2,
		carrierAccountSetUpOrder: 3,
		paymentSetUpOrder: 4,
	},
	day: 5,
	todayTransactionFeesPostPay: 0,
	todayTransactionPostPay: 0.0,
});



// WEBPACK FOOTER //
// ./src/models/dashboard.models.ts